import React from "react";

import TableHeader from "../../../../components/TableHeader/index";
import Pagination from "../../../../components/Pagination";
import PaymentController from "../../../../services/qlts/payment-controller";
import ModalCreateCustomerPayment from "./modalCreateCustomerPayment";
import moment from "moment";
import {checkPermission} from "../../../../utils/common";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {createSearchParams} from "react-router-dom";
import ModalEditCustomerPayment from "./modalEditCustomerPayment";

class ListCustomerPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            pageNumber: 0,
            pageSize: 10,

            sort: 'ASC',
            descending: 'DESC',
            totalItem: 0,
            contentChat: "",
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "money",
                    name: "Tiền nộp",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Chú thích",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "created_date",
                    name: "Ngày",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "edit",
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        this.setState({
            showLoading: true,
            customerId:  nextProps.customerId,
            childName:  nextProps.childName,
        }, () =>{
            this.getListCustomerPayment()
        })

    }
    renderStatus(status){
        if (status == "INACTIVE")
            return <span className="badge badge-danger" style={{color: "white"}}>Khóa</span>
        else if (status == "LOCK")
            return <span className="badge badge-warning" style={{color: "white"}}>Khóa giao dịch</span>
        else
            return <span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>
    }
    getListCustomerPayment() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            customerId: this.state.customerId,
            sort: "created_at desc"
        };
        PaymentController.getList(payload, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        listData: data.content,
                        totalItem: data.totalElements,
                        totalPage: Math.round(data.totalElements / this.state.pageSize),
                        showLoading: false
                    }
                );
            } else {
                this.setState(
                    {
                        showLoading: false
                    }
                );
            }
        });
    }
    formatMoney(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListCustomerPayment();
            }
        );
    };

    // ------------------------------------------------------------------------------------------------------

    render() {
        let {listData, pageNumber, header} = this.state;
        return (
            <div className="row">
                <div className="col-12 p-2 mb-2 bg-info bg-gradient text-white">Lịch sử giao dịch nộp tiền</div>
                <div className="col-xs-12 col-sm-12 col-md-12 p-0 d-flex"
                     style={{
                         alignItems: "center",
                         justifyContent: "right",
                         marginTop: "10px"
                     }}>
                    <button
                        type="button"
                        className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                        onClick={() => {
                            this.setState({itemSelected: {
                                    customerId: this.state.customerId,
                                    childName: this.state.childName
                                }, showModalCreateCustomerPayment: true})
                        }}
                    >
                                        <span className='d-flex justify-content-center'>
                                            Thêm
                                        </span>
                    </button>
                </div>
                <div className="col-12 p-2 mb-2">
                    <div className="p-0 mb-3">
                        <div className="table-wrapper">
                            <table
                                className="table table-striped table-data table-responsive table-bordered">
                                <table className="table">
                                    <thead>
                                    <TableHeader
                                        header={header}
                                        clickSort={data => {
                                            let a = "";
                                            let descend = "";
                                            if (data.sortAsc == null) {
                                                // a = "id=asc";
                                                a = "id";
                                                descend = 'DESC'
                                            } else {
                                                a = data.sortId;
                                                descend = data.sortAsc ? 'ASC' : 'DESC'
                                            }
                                            this.setState(
                                                {
                                                    sort: a,
                                                    descending: descend
                                                },
                                                () => this.getListCustomerPayment()
                                            );
                                        }}
                                    />
                                    </thead>
                                    {!this.state.listData ||
                                    this.state.listData.length == 0 ? (
                                        <tbody>
                                        <tr>
                                            <td colSpan={12}>
                                                <div className="text-center">
                                                    Không có dữ liệu
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    ) : (
                                        <tbody>
                                        {listData &&
                                            listData.length > 0 &&
                                            listData?.map((row, index) => (
                                                <tr style={{height: 50}}>
                                                    <td style={{textAlign: "center"}} scope="row">
                                                        {" "}
                                                        {this.state.pageNumber * this.state.pageSize +
                                                            index +
                                                            1}
                                                    </td>
                                                    <td style={{textAlign: "left"}} scope="row">
                                                        {this.formatMoney(row.money)} VNĐ
                                                    </td>
                                                    <td style={{textAlign: "left"}} scope="row">
                                                        {row.content}
                                                    </td>
                                                    <td style={{textAlign: "left"}} scope="row">
                                                        {moment(row.payDate).format("DD-MM-YYYY").toString()}
                                                    </td>
                                                    <td style={{textAlign: "center"}} scope="row">
                                                        {this.renderStatus(row.status)}
                                                    </td>
                                                    <td style={{textAlign: "center"}}>
                                                        <button className="btn btn-action p-2"
                                                                title='Sửa'
                                                                style={{cursor: 'pointer'}}
                                                                onClick={() => {
                                                                    this.setState({itemSelected: {
                                                                            customerId: this.state.customerId,
                                                                            childName: this.state.childName,
                                                                            data: row
                                                                        }, showModalEditCustomerPayment: true})
                                                                }}
                                                        >
                                                            <i className="ti-pencil-alt"/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    )}
                                </table>
                            </table>
                        </div>
                        <div className="pagination-right">
                            <Pagination
                                activePage={this.state.pageNumber}
                                itemsCountPerPage={this.state.pageSize}
                                totalItemsCount={this.state.totalItem}
                                changeHandler={page => this.handleChangePage(page)}
                            />
                        </div>
                    </div>
                </div>
                <ModalCreateCustomerPayment
                    show={this.state.showModalCreateCustomerPayment}
                    onHide={() => this.setState({showModalCreateCustomerPayment: false})}
                    onRefresh={() => this.getListCustomerPayment()}
                    info={this.state.itemSelected}
                />
                <ModalEditCustomerPayment
                    show={this.state.showModalEditCustomerPayment}
                    onHide={() => this.setState({showModalEditCustomerPayment: false})}
                    onRefresh={() => this.getListCustomerPayment()}
                    info={this.state.itemSelected}
                />
            </div>
        );
    }
}
export default ListCustomerPayment;
